import {toast} from "react-toastify"
import {IEnvLanguages} from "store/system/environment/env.model"

const langCcaMapper: { [key: string]: IEnvLanguages } = {
  en: "eng",
  nl: "nld",
}

export const langCca2To3 = (cca2: string) => {
  return langCcaMapper[cca2] as IEnvLanguages ?? ''
}

export const langCca3To2 = (cca3: string): IEnvLanguages => {
  const cca2 = Object.entries(langCcaMapper).find(map => map[1] === cca3)
  if (!cca2) {
    toast.error('langCca3To2.language.not.found')
    return undefined
  }
  // Returns the key
  return cca2[0] as IEnvLanguages
}

export const supportedLanguages = () => Object.values(langCcaMapper)
